export default __webpack_public_path__ + "static/media/icon-our-goal-mobile2.7909d4a2.svg";